import { observable, computed, reaction, action, toJS } from 'mobx'
import last from 'lodash/last'
import analytics from 'misc/analytics'
import { rulesEngine } from '@taxfyle/rules-engine'
import { task } from 'mobx-task'

export default class QuestionsState {
  stepId = 'Questions'
  trackingId = 'Onboarding - Swipable Questions'

  @observable currentQuestionId = null
  @observable answers = []
  @observable.ref engine = null

  constructor ({ wizard }) {
    this.wizard = wizard
  }

  initialize () {
    this.destroyProjectTypeReaction = reaction(
      () => this.wizard.getStep('ProjectType').legend,
      () => this.loadQuestions()
    )
  }

  destroy () {
    this.destroyProjectTypeReaction && this.destroyProjectTypeReaction()
  }

  @computed get questions () {
    if (!this.engine) {
      return []
    }

    return this.engine.questions(this.answers)
  }

  @computed get title () {
    return `Tell us about it`
  }

  @computed get nextEnabled () {
    if (this.currentQuestion && this.currentQuestion.type === 'BREAKER') {
      // undefined = hide button
      return undefined
    }

    return true
  }

  @computed get currentQuestionIndex () {
    return this.questions.indexOf(this.currentQuestion)
  }

  @computed get currentQuestion () {
    return this.questions.find(x => x.id === this.currentQuestionId)
  }

  @action resetAnswers () {
    this.answers.replace([])
    this.setQuestion(this.questions[0])
  }

  @action breaker (question) {
    switch (question.action) {
      case 'GO_TO_PERSONAL_RETURN':
        return this.wizard.getStep('ProjectType').selectType('PERSONAL_TAX_RETURN')
      case 'GO_TO_PROJECTS':
      default:
        return this.wizard.setStep(this.wizard.getStep('ProjectType'))
    }
  }

  @action setQuestion (question) {
    this.currentQuestionId = question.id
    this.wizard.updateIntercom({
      last_question: question.question,
      last_question_id: question.id
    })
  }

  @action giveAnswer (id, answer) {
    const existing = this.answers.find(x => x.id === id)
    if (existing) {
      existing.answer = answer
    } else {
      this.answers.push({ id, answer })
    }

    this.wizard.syncJob()

    // For tracking..
    const legendId = this.wizard.getStep('ProjectType').legend.id
    let type = legendId
    if (legendId === 'PERSONAL_TAX_RETURN') {
      type = 'Personal'
    } else if (legendId === 'BUSINESS_TAX_RETURN') {
      type = 'Business'
    }

    analytics.track('Onboarding Question', {
      Type: type,
      Question: id,
      Answer: answer
    })

    // This is actually legit use of setTimeout bro
    setTimeout(() => {
      this.wizard.next()
    }, 100)
  }

  @action next () {
    if (this.currentQuestionIndex === this.questions.length - 1) {
      const unanswered = this.questions.filter(x => x.answer === undefined)
      if (unanswered.length === 0) {
        return true
      } else {
        this.setQuestion(unanswered[0])
        return false
      }
    }

    this.setQuestion(this.questions[this.currentQuestionIndex + 1])
  }

  @action back (previousStep) {
    if (this.currentQuestionIndex === 0) {
      previousStep()
      return
    }

    this.setQuestion(this.questions[this.currentQuestionIndex - 1])
  }

  @task async activate () {
  }

  @action loadQuestions () {
    const projectTypeStep = this.wizard.getStep('ProjectType')
    const selectedLegend = projectTypeStep.legend
    if (!selectedLegend) {
      return
    }
    this.legend = selectedLegend

    Object.assign(selectedLegend, selectedLegend)
    this.engine = rulesEngine({
      stories: JSON.parse(JSON.stringify(selectedLegend.stories))
    })

    this.resetAnswers()
  }

  serializeToJob () {
    return {
      answers: toJS(this.answers)
    }
  }

  hydrate (job) {
    if (job.answers) {
      this.answers = JSON.parse(JSON.stringify(job.answers))
    }

    if (this.questions.length > 0) {
      const question = this.questions.find(x => x.answer === undefined) || last(this.questions)
      this.setQuestion(question)
    }
  }
}



// WEBPACK FOOTER //
// ./src/client/screens/ProjectWizard/Steps/Questions/QuestionsState.js